// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VacanciesRouteImport } from './routes/vacancies'
import { Route as TeamRouteImport } from './routes/team'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as HealthRouteImport } from './routes/health'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R404RouteImport } from './routes/404'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsTacticalDronesRouteImport } from './routes/products/tactical-drones'
import { Route as ProductsIrisRouteImport } from './routes/products/iris'
import { Route as ProductsChornaRouteImport } from './routes/products/chorna'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleVacanciesRouteImport } from './routes/$locale/vacancies'
import { Route as LocaleTeamRouteImport } from './routes/$locale/team'
import { Route as LocalePrivacyRouteImport } from './routes/$locale/privacy'
import { Route as LocaleCookiesRouteImport } from './routes/$locale/cookies'
import { Route as LocaleAboutRouteImport } from './routes/$locale/about'
import { Route as LocaleProductsTacticalDronesRouteImport } from './routes/$locale/products/tactical-drones'
import { Route as LocaleProductsIrisRouteImport } from './routes/$locale/products/iris'
import { Route as LocaleProductsChornaRouteImport } from './routes/$locale/products/chorna'

const VacanciesRoute = VacanciesRouteImport.update({
            id: '/vacancies',path: '/vacancies',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsTacticalDronesRoute = ProductsTacticalDronesRouteImport.update({
            id: '/products/tactical-drones',path: '/products/tactical-drones',getParentRoute: () => rootRouteImport
          })
const ProductsIrisRoute = ProductsIrisRouteImport.update({
            id: '/products/iris',path: '/products/iris',getParentRoute: () => rootRouteImport
          })
const ProductsChornaRoute = ProductsChornaRouteImport.update({
            id: '/products/chorna',path: '/products/chorna',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocaleVacanciesRoute = LocaleVacanciesRouteImport.update({
            id: '/vacancies',path: '/vacancies',getParentRoute: () => LocaleRoute
          })
const LocaleTeamRoute = LocaleTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => LocaleRoute
          })
const LocalePrivacyRoute = LocalePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LocaleRoute
          })
const LocaleCookiesRoute = LocaleCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => LocaleRoute
          })
const LocaleAboutRoute = LocaleAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LocaleRoute
          })
const LocaleProductsTacticalDronesRoute = LocaleProductsTacticalDronesRouteImport.update({
            id: '/products/tactical-drones',path: '/products/tactical-drones',getParentRoute: () => LocaleRoute
          })
const LocaleProductsIrisRoute = LocaleProductsIrisRouteImport.update({
            id: '/products/iris',path: '/products/iris',getParentRoute: () => LocaleRoute
          })
const LocaleProductsChornaRoute = LocaleProductsChornaRouteImport.update({
            id: '/products/chorna',path: '/products/chorna',getParentRoute: () => LocaleRoute
          })





const LocaleRouteChildren = {
  LocaleAboutRoute: LocaleAboutRoute,LocaleCookiesRoute: LocaleCookiesRoute,LocalePrivacyRoute: LocalePrivacyRoute,LocaleTeamRoute: LocaleTeamRoute,LocaleVacanciesRoute: LocaleVacanciesRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleProductsChornaRoute: LocaleProductsChornaRoute,LocaleProductsIrisRoute: LocaleProductsIrisRoute,LocaleProductsTacticalDronesRoute: LocaleProductsTacticalDronesRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,LocaleRoute: LocaleRouteWithChildren,R404Route: R404Route,AboutRoute: AboutRoute,CookiesRoute: CookiesRoute,HealthRoute: HealthRoute,PrivacyRoute: PrivacyRoute,TeamRoute: TeamRoute,VacanciesRoute: VacanciesRoute,ProductsChornaRoute: ProductsChornaRoute,ProductsIrisRoute: ProductsIrisRoute,ProductsTacticalDronesRoute: ProductsTacticalDronesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)